<template>
  <div class="ml-n1">
    <div class="px-1">
      <v-carousel
        v-if="files.length"
        v-model="activeFileIndex"
        hide-delimiters
        :height="activeFileHeight"
        class="mb-2shadowed-box"
      >
        <template v-slot:prev="{attrs, on}">
          <v-btn
            v-show="files.length > 1"
            class="carousel-nav-button"
            color="white"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon
              :size="28"
              color="primary"
            >
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:next="{attrs, on}">
          <v-btn
            v-show="files.length > 1"
            class="carousel-nav-button"
            color="white"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon
              :size="28"
              color="primary"
            >
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </template>

        <v-carousel-item
          v-for="file in files"
          :key="file.id"
          :src="isImageFile(file) ? file.url : undefined"
        >
          <a
            v-if="!isImageFile(file)"
            :href="!file.removed && file.url"
            target="_blank"
            :download="file.filename"
          >
            <div class="d-flex flex-column align-center justify-center h-100">
              <img
                class="placeholder-icon--big"
                :src="require(`@/assets/img/file-icon_${getFileFormat(file)}.svg`)"
              >
              <span>{{ file.filename }}</span>
            </div>
          </a>
        </v-carousel-item>
      </v-carousel>
    </div>

    <carousel
      v-model="activeFileIndex"
      :loop="true"
      :per-page="carouselColumns"
      :scroll-per-page="false"
      :pagination-enabled="false"
    >
      <slide
        v-for="(file, index) in files"
        :key="'file' + file.id"
        @slideclick="activeFileIndex = index"
      >
        <div
          v-if="isImageFile(file)"
          class="preview-slide shadowed-box"
          :style="`background-image: url(${getUrl(file.url)}); height: ${sliderHeight}px`"
        />
        <div
          v-else
          class="preview-slide shadowed-box"
          :style="`height: ${sliderHeight}px`"
        >
          <img
            class="placeholder-icon"
            :src="require(`@/assets/img/file-icon_${getFileFormat(file)}.svg`)"
          >
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import utils from '@/helpers/utils';
import checkFileExtension from '@/mixins/checkFileExtension.vue';
import { Carousel, Slide } from 'vue-carousel';

export default {
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  components: {
    Carousel,
    Slide,
  },
  mixins: [checkFileExtension], // getFileFormat, isImageFormat
  data: () => ({
    activeFileIndex: 0,
  }),
  computed: {
    activeFile() {
      return this.files[this.activeFileIndex];
    },
    carouselColumns() {
      return utils.getResponsiveValues.call(this, 6, 4, 4, 3, 2);
    },
    activeFileHeight() {
      return utils.getResponsiveValues.call(this, 600, 400, 500, 300, 100);
    },
    sliderHeight() {
      return utils.getResponsiveValues.call(this, 88, 80, 90, 80);
    },
  },
  methods: {
    getUrl(url) {
      return encodeURI(url).replace(/[!'()*]/g, (c) => `%${ c.charCodeAt(0).toString(16)}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-slide {
  max-width:100%;
  margin:4px;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shadowed-box {
  box-shadow: 3px 0px 6px rgba(93, 167, 160, 0.2);
}
.placeholder-icon {
  height: 48px;
  width: 48px;
  &--big {
    height: 96px;
    width:96px;
  }
}
</style>
